import './NavigationBar.css';
import Container from 'react-bootstrap/Container';
// import Fade from 'react-bootstrap/Fade'
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link, useNavigate } from 'react-router-dom';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { getUserInfo } from "./../shared/UserUtility.js";
import { PersonCircle } from 'react-bootstrap-icons';

function NavigationBar({ bgFn }) {
    const redirect = window.location.pathname;
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleLogout = (event) => {
        event.preventDefault();

        // logout
        sessionStorage.removeItem('dXNlcl9sb2dnZWQ=');
        sessionStorage.removeItem('curr_user');
        setUserName(false);

        const requestOptions = {
            mode: 'no-cors'
        };

        fetch('/.auth/logout?post_logout_redirect_uri=' + redirect, requestOptions)
            .then((_) => {
                handleClose();
                window.location.reload(false);
            });
    }

    const [userInfo, setUserInfo] = useState(null);
    const [userName, setUserName] = useState(sessionStorage.getItem('curr_user'));

    useEffect(() => {
        getUserInfo().then((loggedUserInfo) => {
            setUserInfo(loggedUserInfo);

            setUserName(loggedUserInfo.userDetails);
            sessionStorage.setItem('curr_user', loggedUserInfo.userDetails);

            if (loggedUserInfo) {
                let currUserAPI = sessionStorage.getItem('dXNlcl9sb2dnZWQ=');
                if (!currUserAPI) {
                    fetch(process.env.REACT_APP_IP_API_URL).then(response => {
                        if (response.ok) {
                            response.text().then(value => {
                                loggedUserInfo.currIp = value;

                                const requestOptions = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(loggedUserInfo)
                                };

                                fetch(process.env.REACT_APP_USER_API_URL, requestOptions)
                                    .then(response => {
                                        if (response.ok) {
                                            sessionStorage.setItem('dXNlcl9sb2dnZWQ=', 'success');
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    });
                            });
                        } else {
                            console.log('Navi ipLoc status: ' + response.status);
                        }
                    });
                }
            } else {
                console.log('No longer authenticated. Please log in again.');
            }
        }).catch(() => {
            // If not authenticated, it will always reach this code block.
            // console.log('Authentication currently disabled. Go to Contact, and feel free to send me an inquiry.')
            sessionStorage.removeItem('curr_user');
        });
    }, []);

    // Removed currWidth state - using pure CSS media queries instead
    // This prevents state updates from interrupting the navbar collapse animation

    // function enlargePicture() {
    //     window.open('/assets/logo/jk_logo_nature.jpeg', 'targetWindow', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1090px, height=550px, top=25px left=120px');
    //     return false;
    // }

    function navigateToHome() {
        navigate('/');
    }

    // const navbarStyle = window.location.pathname === '/' || window.location.pathname === '/blogs' ? { '--bs-bg-opacity': '0.25' } : { '--bs-bg-opacity': '1' };

    return (
        <>
            <style>
                {
                    `
                    @keyframes pulse-with-pause {
                        /* 0% to 16.6% handles the actual 2-second movement */
                        0%, 16.6%, 100% { transform: scale(1); }
                        8.3% { transform: scale(1.2); } 
                        
                        /* 16.7% to 100% is the "dead air" where nothing happens */
                    }
                    `
                }
            </style>
            <Navbar bg="dark" expand="lg" style={{ '--bs-bg-opacity': '0.25', 'zIndex': '1' }}>
                <Container>
                    <Navbar.Brand style={{ cursor: "default" }}>
                        <img width="40"
                            alt="Home Logo"
                            src="/assets/logo/jk_logo_nature.jpeg"
                            onClick={navigateToHome}
                            style={{ cursor: 'pointer', animation: 'pulse-with-pause 10s ease-in-out infinite' }} />
                        {
                            userName
                            &&
                            <span className="ms-3" style={{ color: 'white' }}>Welcome {userName}!</span>
                        }
                        {
                            !userName
                            &&
                            <span className="ms-3" onClick={bgFn} style={{ color: 'white' }}>Home</span>
                        }
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ background: 'white' }}>
                        {/* <i class="icon-collapse"></i> */}
                    </Navbar.Toggle>
                    <Navbar.Collapse className="justify-content-end flex-grow-1 pe-3">
                        <Nav style={{ alignItems: 'center' }}>
                            <Nav.Link className="nav-link-responsive" style={{ color: 'white' }} as={Link} to="/about">About</Nav.Link>
                            <Nav.Link className="nav-link-responsive" as="span">
                                <button
                                    className="login-button"
                                    onClick={handleShow}
                                    aria-haspopup="dialog"
                                    aria-expanded={show}
                                    title={userName ? `Account (${userName})` : 'Log in'}
                                >
                                    {
                                        userName
                                            ? <span className="login-initials">{(userName || '').split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()}</span>
                                            : <PersonCircle size={24} />
                                    }
                                </button>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {
                !userInfo
                &&
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <img alt="Github Logo" src="/assets/icons/github.png" />
                        {' '}
                        <a href={`/.auth/login/github?post_login_redirect_uri=${redirect}`}>Via Github</a>
                    </Modal.Body>
                    <Modal.Body>
                        <img alt="Github Logo" src="/assets/icons/hierarchy.png" />
                        {' '}
                        <a href={`/.auth/login/aad?post_login_redirect_uri=${redirect}`}>Via Azure AD</a>
                    </Modal.Body>
                    <Modal.Body>
                        <img alt="Github Logo" src="/assets/icons/twitter.png" />
                        {' '}
                        <a href={`/.auth/login/twitter?post_login_redirect_uri=${redirect}`}>Via Twitter</a>
                    </Modal.Body>
                </Modal>
            }
            {
                userInfo
                &&
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Logout</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={handleClose}>
                            No
                        </Button>
                        <Button variant="outline-primary" onClick={handleLogout}>
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

export default NavigationBar;